module.exports = __webpack_public_path__ + "static/media/clothes_title@2x.4b1afc5f.png";